import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of, BehaviorSubject } from 'rxjs'
import { apiUrl } from './../../config/api-url'
import { catchError, tap, map } from 'rxjs/operators'
import { PrivateLabelService } from '../../content/pages/showroom/private-label.service'
import { CanActivate } from '@angular/router'
import { Vendor } from './../../models/common/vendor'
import { Showroom } from './../../models/showroom/showroom'
import { MixpanelService } from '../integration/mixpanel.service'

export interface IUserData {
  user?: any
  company?: Showroom | Vendor
  private_label?: {
    is_private_label: boolean
    manufacturer: Vendor
  }
  integrations?: {
    quickbooks?: {
      create_invoice: boolean
    }
  }
  company_short_name?: string
}

@Injectable({
  providedIn: 'root',
})
export class UserDataService implements CanActivate {
  public userData$: Observable<IUserData>

  private userDataSubject = new BehaviorSubject({})

  private _snapshot: IUserData

  constructor(
    private http: HttpClient,
    private mixpanel: MixpanelService,
    private privateLabelService: PrivateLabelService
  ) {
    this.userData$ = this.userDataSubject.asObservable()
  }

  public getSnapshot(): IUserData {
    return this._snapshot
  }

  public canActivate() {
    return this.getData().pipe(map(() => true))
  }

  public getData(): Observable<IUserData> {
    return this.http.get<IUserData>(`${apiUrl}/shared/user-data`).pipe(
      tap((response: IUserData) => this.setData(response)),
      catchError(() => of({}))
    )
  }

  public setData(data: IUserData): void {
    this._snapshot = data
    this.userDataSubject.next(data)
    this.privateLabelService.setData(data.private_label)
    this.mixpanel.setUser({
      ...data.user,
      pricing_plan: data.company.pricing_plan,
    })
  }
}
